export default {
  state: {
    info: {
      token: '',
      userimg: require('../common/image/avatar.png'),
      personal_logreg: '登录/注册',
      orderstate: 0,
      rolesState: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js